import React from 'react';

import Input from './Input';

import './styles/style.scss';

export const Textarea = props => <Input multiline {...props} />;
Textarea.displayName = 'Textarea';

export default Input;



// WEBPACK FOOTER //
// ./src/components/Forms/Input/index.js